import { render, staticRenderFns } from "./ShareQ.vue?vue&type=template&id=5b3c5500&"
import script from "./ShareQ.vue?vue&type=script&lang=ts&"
export * from "./ShareQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports